import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IInventionDisclosureState {
  name: string;
  description: string;
}

const initialState: IInventionDisclosureState = {
  name: '',
  description: '',
};

const launchpadSlice = createSlice({
  name: 'launchpad',
  initialState,
  reducers: {
    setInventionDisclosure: (state, action: PayloadAction<IInventionDisclosureState>) => {
      state.description = action.payload.description;
      state.name = action.payload.name;
    },
    setName: (state, action: PayloadAction<string>) => {
      state.name = action.payload;
    },
    setDescription: (state, action: PayloadAction<string>) => {
      state.description = action.payload;
    },
    clearInventionDisclosure: () => initialState,
  },
});

export default launchpadSlice.reducer;

export const { setName, setDescription, setInventionDisclosure } = launchpadSlice.actions;
